module.exports = __webpack_public_path__ + "static/media/agility.751f8703.png";